import { Box, Flex, Group, Skeleton, Stack } from '@mantine/core';
import { useStyles } from './styles';

export function PolicyTableLoadingState({
	showScoreColumn,
}: {
	showScoreColumn: boolean;
}) {
	const { classes } = useStyles();
	return (
		<Flex h="50vh" direction="column" p={0} sx={{ overflowY: 'auto' }}>
			{Array.from({ length: 8 }, (_, i) => `skeleton-${i}`).map(
				(skeletonKey) => (
					<Box key={skeletonKey} className={classes.rowContainer}>
						<Flex className={classes.resourceColumn}>
							<Group spacing="sm">
								<Skeleton circle height={24} width={24} />
								<Stack spacing={4}>
									<Skeleton height={12} width={150} />
									<Skeleton height={10} width={100} />
								</Stack>
							</Group>
						</Flex>
						<Flex className={classes.conditionsColumn}>
							<Skeleton height={20} width={80} />
						</Flex>
						{showScoreColumn && (
							<Flex className={classes.scoreColumn}>
								<Skeleton height={12} width={60} />
							</Flex>
						)}
						<Flex className={classes.dateColumn}>
							<Skeleton height={12} width={120} />
						</Flex>
					</Box>
				)
			)}
		</Flex>
	);
}
